import * as createOrUpdateReportFacadeImpl from "./createOrUpdateReportFacadeImpl";
import * as fileDownloadTaskFacadeImpl from "./fileDownloadTaskFacadeImpl";
import * as fileDownloadTaskRecord from "./fileDownloadTaskRecord";
import * as importTaskRecord from "./importTaskRecord";
import * as importTaskRecordFacadeImpl from "./importTaskRecordFacadeImpl";
import * as reportTaskRecord from "./reportTaskRecord";
import * as test from "./test";

export const report = {
  createOrUpdateReportFacadeImpl,
  fileDownloadTaskFacadeImpl,
  fileDownloadTaskRecord,
  importTaskRecord,
  importTaskRecordFacadeImpl,
  reportTaskRecord,
  test,
};
